import { CoreItem, CoreItemBackend } from '../core-item/core-item';

export interface ReportBackend extends CoreItemBackend {
  unsafeSubData: ReportUnsafeSubData;
}

export interface Report extends CoreItem {
  unsafeSubData: ReportUnsafeSubData;
}

export interface ReportUnsafeSubData {
  timeInterval: ReportTimeInterval;
}

export enum ReportTimeInterval {
  daily = 'Daily',
  weekly = 'Weekly',
  monthly = 'Monthly',
}

export const reportList = [
  {
    name: 'string',
    timeInterval: ReportTimeInterval.weekly,
  },
];
